import Store from 'store/store';
import cached from 'utils/cached';
import parseQueryString from 'utils/parseQueryString';
import { parseDate } from 'utils/utils';
import formatDateTime from 'utils/formatDateTime';
import hooks from 'utils/hooks';
import slugify from 'utils/slugify';

const defaultDate = cached(() => {
	let value = parseDate(Store.get().appData?.pages?.boltShowtimes?.data?.defaultDate);
	return !Number.isNaN(+value) ? formatDateTime(value, 'yyyy-MM-dd') : null;
});

const fromCommaSeparated = value => typeof value === 'string' && value.split(',').map(e => e.trim()).filter(e => e);
const validTimes = ['morning', 'afternoon', 'evening', 'late'];
export const getBaseFilters = async (qs) => {
	let query = parseQueryString(qs);
	let result = {};

	result.audioDetails = [];
	const formatArray = fromCommaSeparated(query.format);
	if (formatArray?.length) {
		result.format = formatArray;
		if (result.format.includes('dolby')) {
			result.format = result.format.filter(e => e !== 'dolby');
			result.audioDetails.push('Dolby Cinema');
		}
	}
	const timeArray = (fromCommaSeparated(query.time) || []).filter(e => validTimes.includes(e));
	if (timeArray?.length) {
		result.time = timeArray;
	}
	const exhibitor = fromCommaSeparated(query.chain || query.exhibitor);
	if (exhibitor?.length) {
		result.exhibitor = exhibitor;
	}

	const queryArray = fromCommaSeparated(query.movie || query.title);

	if (queryArray?.length) {
		const movieDataEntries = Object.entries(Store.get().appData?.pages?.boltShowtimes?.data?.movieData || {});

		const queryMovieIds = queryArray.map(q => {
			const matchingEntry = movieDataEntries.find(entry => {
				const [movieId, movieData] = entry;
				const slug = movieData.querySlug || slugify(movieData.title, { replaceAccentedChars: true });
				return q === slug;
			});
			if (matchingEntry) {
				return matchingEntry[0];
			}
			return q;
		});

		let movie = await hooks.call('querystring.filters.movie', queryMovieIds);

		if (movie?.length) {
			result.movie = movie;
		}
	}

	// today's date is in store anyway, so no need to account for that here
	const desiredDate = parseDate(query.date);
	const baseDefaultDate = defaultDate();
	let now = Date.now();
	if (desiredDate && !Number.isNaN(+desiredDate) && desiredDate > now) {
		result.date = [formatDateTime(desiredDate, 'yyyy-MM-dd')];
	} else if (baseDefaultDate && new Date(baseDefaultDate) > now) {
		result.date = [baseDefaultDate];
	}

	return result;
};
